<template>
  <div class="org-tree-panel" :class="{ multiple: multiple }" @click.stop>
    <div :id="'input' + _uid" v-if="!isSelect || filterable">
      <Input search enter-button v-model="keyword" @input="inputChange" @click.native="inputClick" @on-search="search($event)" placeholder="搜索关键字或内部组织编码" />
    </div>    
    <div class="commission-tips" v-if="showConfigTemplateText">
      “标*的为未配置产品的组织”
    </div>
    <search-result ref="searchBox" :source="source" v-if="keyword && isSearch" @selectChange="selectChange"></search-result>
    <Tree
      ref="tree"
      v-else
      :data="searchResultData"
      :render="renderContent"
      @on-select-change="selectChange"
      :check-strictly="true"
      :show-checkbox="multiple"
      @on-check-change="checkChange"
    ></Tree>
  </div>
</template>

<script>
import searchResult from './searchResult';
export default {
  components: { searchResult },
  props: {
    checkChild: {
      default: true
    }, //多选时选择父级是否关联子集
    value: null, //当前选中
    source: null, //1所有，2排除渠道
    multiple: null, //是否显示多选框
    selectAll: {//多选时是否默认全选
      default: true
    },
    filterable: null, //是否显示查询
    isSelect: null, //是否是下拉选择组件中
    isAll: {
      //顶级是否可选
      default: true
    },
    isTopCheck: {
      // 顶级是否禁用不允许勾选
      default: false
    },
    selectAllChildren: null,
    showConfigTemplateText: false
  },
  data() {
    return {
      ajaxUrl: '',
      params: null,
      keyword: '',
      isSearch: false,
      treeData: [],
      searchResultData: [],
      list: [],
      searchResultList: [],
      forceInit: false
    };
  },
  watch: {
    value: {
      handler() {
        this.foreachTree(this.searchResultData, this.value);
      },
      deep: true
    }
  },
  mounted() {
    if (this.isSelect) {
      return;
    }
    this.$nextTick(()=>{
      if (this.$route.query.type == 1) {
      //机构
      this.getTreeData(this.$route.query.organizationId);
    } else if (this.$route.query.type == 2) {
      //团队
      this.getTreeData(this.$route.query.groupId);
    } else {
      this.getTreeData();
    }
    })
    
  },
  methods: {
    init(ajaxUrl, params, forceInit = false) {
      this.forceInit = forceInit;
      if (this.treeData.length && !forceInit) {
        return;
      }
      this.ajaxUrl = ajaxUrl || '';
      this.params = params || null; //此参数传了source就无效
      this.getTreeData();
    },
    setData(data, id) {
      let isArray = data instanceof Array;
      this.list = [];
      this.searchResultList = [];
      // 避免第2次进入初始化数据缓存勾选状态
      this.$nextTick(() => {
        if (this.isSelect) {
          const treeData = this.foreachTree(isArray ? data : [data], this.value);
          this.treeData = JSON.parse(JSON.stringify(treeData));
          this.searchResultData = treeData;
          this.foreachToList(this.treeData, this.list);
          this.foreachToList(this.searchResultData, this.searchResultList);
          // 多选时 无勾选数据默认勾选全部
          if (this.multiple && (!this.value || this.value.length == 0) && this.selectAll) {
            this.$nextTick(() => {
              this.foreachTreeCheck(treeData, true);
              this.setSelectIdByChecked();
            });
          } else {
            this.emitData();
          }
        } else {
          this.searchResultData = this.foreachTree(isArray ? data : [data], [id]);
          if (!id && !this.forceInit) {
            data.selected = true;
            this.$emit('change', data);
          }
        }
        this.$emit('getTreeData', this.searchResultData, this.list);
      });
    },
    // select中需要手动获取焦点
    inputClick() {
      const input = document.getElementById('input' + this._uid).querySelector('input');
      input.focus();
    },
    // 查询
    inputChange() {
      if (this.isSelect) {
        this.searchKeyword(this.keyword);
      } else {
        this.keyword == '';
        this.isSearch = false;
      }
    },
    search() {
      if (!this.keyword || this.isSelect) {
        return;
      }
      this.isSearch = true;
      this.$nextTick(() => {
        this.$refs.searchBox.search(this.keyword);
      });
    },
    getTreeData(id) {
      this.search();
      const ajaxUrl = this.ajaxUrl || '/buz/organizationBase/read/tree';
      const params = this.params || { source: this.source };
      this.list = [];
      this.$http({
        url: ajaxUrl,
        type: 'post',
        data: params
      }).then(res => {
        res.data.isTop = true;
        // 顶级禁用
        if (!this.isAll) {
          res.data.disabled = true;
        }
        // 禁用顶级不进行勾选,
        if(this.isTopCheck) {
          res.data.disabled = true;
          res.data.id = '';
        }
        this.setData(res.data, id);
      });
    },
    searchKeyword(keyword) {
      let arr = JSON.parse(JSON.stringify(this.treeData));
      if (keyword) {
        this.searchResultData = this.filterTree(arr, keyword);
      } else {
        this.searchResultData = arr;
      }
      this.searchResultList = [];
      this.foreachToList(this.searchResultData, this.searchResultList);
    },
    // 搜索关键字字段过滤
    filterTree(arr, keyword) {
      let emptyArr = [];
      for (let item of arr) {
        if (item.name.includes(keyword) || item.code.includes(keyword)) {
          // if (item.children &&Array.isArray(item.children)&& item.children.length > 0) {
          //   item.children = this.filterTree(item.children, keyword);
          // }
          emptyArr.push(item);
        } else if (item.children && Array.isArray(item.children) && item.children.length > 0) {
          item.children = this.filterTree(item.children, keyword);
          if (item.children.length) {
            emptyArr.push(item);
          }
        }
      }
      return emptyArr;
    },
    foreachTree(treeData, ids = []) {
      treeData.forEach(item => {
        this.$set(item, 'expand', true);
        if (ids.includes(item.id)) {
          this.$set(item, 'selected', true);
          this.$set(item, 'checked', true);
          if (!this.isSelect) {
            this.$emit('change', item);
          }
        } else {
          this.$set(item, 'selected', false);
          this.$set(item, 'checked', false);
        }
        if (item.children && item.children.length) {
          this.foreachTree(item.children, ids);
        }
      });
      return treeData;
    },
    // 扁平化数据
    foreachToList(treeData, list) {
      treeData.forEach(item => {
        list.push(item);
        if (item.children && item.children.length) {
          this.foreachToList(item.children, list);
        }
      });
    },
    // 回调数据
    emitData() {
      if (!this.value) {
        return;
      }
      const list = this.list.filter(item => {
        return this.value == item.id || this.value.includes(item.id);
      });
      if (this.multiple) {
        this.$emit('change', {}, list);
      } else {
        this.$emit('change', list[0] || {}, list);
      }
    },
    renderContent(h, { root, node, data }) {
      let hasChild = data.children && data.children.length ? 'has-child' : '';
      let renderIcon = '';
      if (!data.isTop) {
        if (data.orgType == 2) {
          renderIcon = <span class={`tree-icon ${hasChild}`}>省</span>;
        } else if (data.orgType == 3) {
          renderIcon = <span class={`tree-icon org ${hasChild}`}>市</span>;
        } else if (data.orgType == 4) {
          renderIcon = <span class={`tree-icon blue ${hasChild}`}>区</span>;
        } else if (data.orgType == 5) {
          renderIcon = <span class={`tree-icon green ${hasChild}`}>渠</span>;
        } else if (data.orgType == 6) {
          renderIcon = <span class={`tree-icon purple ${hasChild}`}>营</span>;
        }
      }

      let name = '';
      if (data.code) {
        name = data.name + '-' + data.code;
      } else {
        name = data.name;
      }
      let dian = '';
      if (data.orgType) {
        dian = <span class={data.status == 2 ? 'dian red' : 'dian green'}></span>;
      }
      return (
        <div class="tree-item" id={data.id}>
          {dian}
          {renderIcon}
          <span style={{ color:'#C78D49', marginRight: '2px', fontWeight: 'bold' }} >{ this.showConfigTemplateText&&data.hasProduct=='0'&& data.levelCode != 10001 && !data.isTop ? '* ' : '' }</span>
          <span class={`org-name ${data.isTop ? 'isTop' : ''}`}>{name}</span>
        </div>
      );
    },
    // 点击文字选择 多选模式效果与点击多选框一致
    selectChange(arr, data) {
      if (this.multiple) {
        //多选
        if (this.checkChild) {
          //关联子集
          this.selectChild(data.id, data.selected); //方法内部emit
        } else {
          // 同步数据
          const bean = this.list.find(item => item.id == data.id);
          if (bean) {
            this.$set(bean, 'selected', !data.checked);
            this.$set(bean, 'checked', !data.checked);
          }
          const selectArr = this.list.filter(item => item.checked);
          this.$emit('change', data, selectArr);
        }
      } else {
        this.$emit('change', data, arr);
        this.list.forEach(item => {
          if (item.id == data.id) {
            item.selected = true;
            item.checked = true;
          } else {
            item.selected = false;
            item.checked = false;
          }
        });
      }
    },
    // 多选框勾选
    checkChange(arr, data) {
      //只在多选模式触发
      if (this.checkChild) {
        //关联子集
        this.selectChild(data.id, data.checked); //方法内部emit
      } else {
        // 同步数据
        const bean = this.list.find(item => item.id == data.id);
        if (bean) {
          this.$set(bean, 'selected', data.selected);
          this.$set(bean, 'checked', data.checked);
        }
        const selectArr = this.list.filter(item => item.checked);
        this.$emit('change', data, selectArr);
      }
    },
    // 勾选子集
    selectChild(id, checked = true) {
      const data = this.searchResultList.find(item => item.id == id);
      this.foreachTreeCheck([data], checked);
      this.setSelectIdByChecked();
    },
    // 勾选所有节点
    foreachTreeCheck(treeData, checked = true) {
      treeData.forEach(item => {
        this.$set(item, 'checked', checked);
        if (item.children && item.children.length) {
          this.foreachTreeCheck(item.children, checked);
        }
      });
      return treeData;
    },
    // 根据checked状态同步选中id
    setSelectIdByChecked() {
      this.list.forEach(item1 => {
        const data = this.searchResultList.find(item2 => item1.id == item2.id);
        if (data) {
          this.$set(item1, 'checked', data.checked);
          this.$set(item1, 'selected', data.selected);
        }
      });
      const nodes = this.searchResultList.filter(item => item.checked);
      this.$emit('change', {}, nodes);
    },
    // 多选模式 查找是否有未勾选的节点
    findNoSelect(arr) {
      return arr.find(item => {
        if (item.checked) {
          if (item.children && item.children.length) {
            return this.findNoSelect(item.children);
          } else {
            return false;
          }
        } else {
          return item;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './orgTree.scss';
</style>